import { createIcon } from './icon-utils';

export const DeleteTableColumnsIcon = createIcon({
  path: 'M9.01 12.75H9a.75.75 0 0 1-.75-.75v-1.75H4a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v5.25h3.5V3.49c0-.414.336-.74.75-.74a.75.75 0 0 1 .75.75v7.75h4.65V3.5a.75.75 0 1 1 1.5 0v5.25h3.35V3.5a.75.75 0 1 1 1.5 0v6a.75.75 0 0 1-.75.75h-4.1v1.577a.752.752 0 0 1-.73.923H9.01zm4.05 5.093 1.945 1.945a.75.75 0 0 1-1.06 1.06L12 18.904l-1.945 1.944a.75.75 0 0 1-1.06-1.06l1.944-1.945L8.995 15.9a.75.75 0 0 1 1.06-1.061L12 16.782l1.945-1.944a.75.75 0 0 1 1.06 1.06l-1.944 1.945z',
  viewBox: '0 0 24 24',
});
